import {FormEvent} from 'react';

export const formatNumberEvent = (e: FormEvent<HTMLInputElement>) => {
    e.currentTarget.value = e.currentTarget.value.replace(/\s/g, '');
    if (e.currentTarget.value.includes(',')) {
        e.currentTarget.value = e.currentTarget.value.replace(/,/g, '.');
    }
    return e;
};
